<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/casa-ferreirinha')">Casa Ferreirinha
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/howards-folly')">Howard’s Folly
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/prats-and-symington')">Prats and
                        Symington (Chryseia)
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-crasto')">Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vale-meao')">Quinta Do Vale
                        Meao
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vallado')">Quinta Do Vallado
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vesuvio')">Quinta Do Vesuvio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/roquette-cazes-quinta')">Roquette
                        &amp; Cazes — Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/symington')">Symington
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vale Meao</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Menziona il nome di Dona Antónia Adelaide Ferreira in Portogallo e canticchieranno con riverenza. UN
                        motivo di orgoglio nazionale, “la Ferreirinha” - il soprannome dato ad Antonia dai suoi operai - lo è
                        il motivo per cui il vino Porto gode dell'illustre reputazione che ha oggi. L'ultimo pezzo di lei
                        Porto puzzle di proprietà leggendarie (ce n'erano quasi 30 in totale), Quinta Do Vale Meao
                        (pronunciato miao) è una vera e propria istituzione del Douro.
                    </div>

                    <div class="howto-title2">Una delle più grandi tenute familiari della Val Duro</div>
                    <div class="howto-text">
                        A 300 ettari e 200 chilometri da Porto, Quinta Do Vale Meao è stato l'ultimo ma più significativo progetto della Ferreirinha. Piantata nel 1877, alla fine del 1880 gestiva tutte le sue tenute
                        quasi da solo. Eppure iniziare Quinta Do Vale Meao è stato impegnativo; impostato così in alto nel
                        valle il ricco mosaico di terroir era privilegiato per l'uva da vino Porto, ma la distanza (12 giorni
                        corsa su un carro trainato da buoi) era scoraggiante per i lavoratori. Quindi cosa ha fatto la Ferreirinha? Fai pressione sul
                        governo portoghese per costruire la ferrovia fino al Foz Côa, (il villaggio dove Quinta Do Vale
                        Meao si trova) ovviamente. Semplice.
                        <br><br>
                        Oggi la tenuta è gestita dal team fratello e sorella Francisco (Xito) e Luisa Olazabal, the
                        la sesta generazione conduce la vigna. La famiglia sta lentamente ripiantando le viti in singolo
                        blocchi dal 1971, sostituendoli con i vitigni tradizionali per il Porto. Il vino è ricco e
                        complesso, e come alcuni dei suoi vigneti gemelli, le uve vengono ancora pigiate a piedi per quattro
                        ore grandi tini di pietra (detti lagares). La fermentazione, invece, è all'avanguardia e
                        avviene in vasche di acciaio inox a temperatura controllata. L'invecchiamento avviene poi ad Allier
                        Barrique di rovere francese. Tale diligenza e rispetto per la tradizione valsero a Xito il titolo di
                        Enologo portoghese dell'anno nel 2011.
                    </div>

                    <div class="howto-title2">Il futuro è luminoso</div>
                    <div class="howto-text">
                        È interessante vedere che Xito e Luisa hanno grandi progetti per il futuro. L'esportazione è
                        ampio e vario; Quinta Do Vale Meao si trova in Brasile, Canada, Germania, Macao, Svizzera
                        e gli Stati Uniti e Xito e Luisa stanno attivamente cercando altri paesi per importare il loro porto
                        vino. Hanno anche piantato una varietà di uva da vino da tavola, per vedere come reagirà il frutto,
                        anche se solo il tempo dirà i risultati, è dubbio che questa nuova impresa ne produca alcuno
                        opportunità di investimento nel prossimo futuro. Tuttavia, con un pedigree enologico come il loro,
                        potrebbe essere saggio guardare questo spazio.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vale Meao</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Erwähnen Sie in Portugal den Namen Dona Antónia Adelaide Ferreira und sie werden voller Ehrfurcht summen. A
                        Quelle des Nationalstolzes ist „la Ferreirinha“ – der Spitzname, den Antonia von ihren Arbeitern erhielt
                        Der Grund, warum Portwein heute seinen hervorragenden Ruf genießt. Das letzte Stück von ihr
                        Porto, ein Puzzle aus legendären Anwesen (insgesamt waren es fast 30), Quinta Do Vale Meao
                        (ausgesprochen miau) ist eine wahre Institution des Douro.
                    </div>

                    <div class="howto-title2">Eines der größten Familiengüter im Duro-Tal</div>
                    <div class="howto-text">
                        Mit einer Fläche von 300 Hektar und 200 Kilometern von Porto entfernt war Quinta Do Vale Meao das letzte, aber bedeutendste Projekt von La Ferreirinha. Sie wurde 1877 gegründet und verwaltete Ende der 1880er Jahre alle ihre Ländereien
                        fast im Alleingang. Dennoch war es eine Herausforderung, Quinta Do Vale Meao zu starten. so hoch in der
                        Tal war das reiche Flickenteppich-Terroir die beste Wahl für Portwein-Trauben, doch die Distanz (12 Tage)
                        Ochsenkarrenfahrt) war für die Arbeiter abstoßend. Was hat La Ferreirinha also getan? Üben Sie Druck auf die aus
                        Die portugiesische Regierung plant den Bau der Eisenbahn bis nach Foz Côa (dem Dorf, in dem Quinta Do Vale liegt).
                        Meao liegt) natürlich. Einfach.
                        <br><br>
                        Heute wird das Anwesen vom Geschwisterpaar Francisco (Xito) und Luisa Olazabal geführt
                        Sechste Generation bewirtschaftet das Weingut. Die Familie hat die Reben langsam einzeln neu gepflanzt
                        Blöcke seit 1971, ersetzt durch die traditionellen Rebsorten für Porto. Der Wein ist reichhaltig und
                        komplex, und wie bei einigen seiner Schwesterweingärten werden die Trauben immer noch zu viert zu Fuß gestampft
                        Stundenlang große Steinbottiche (Lagares genannt). Die Fermentation ist jedoch auf dem neuesten Stand der Technik
                        erfolgt in temperaturkontrollierten Edelstahltanks. Anschließend erfolgt die Reifung in Allier
                        Barriques aus französischer Eiche. Dieser Fleiß und der Respekt vor der Tradition brachten Xito den Titel ein
                        Portugals Winzer des Jahres 2011.
                    </div>

                    <div class="howto-title2">Die Zukunft ist rosig</div>
                    <div class="howto-text">
                        Es ist interessant zu sehen, dass Xito und Luisa große Pläne für die Zukunft haben. Der Export ist
                        breit und vielfältig; Quinta Do Vale Meao gibt es in Brasilien, Kanada, Deutschland, Macau und der Schweiz
                        und die USA und Xito und Luisa suchen aktiv nach anderen Ländern, um ihren Hafen zu importieren
                        Wein. Sie haben auch verschiedene Tafelweintrauben gepflanzt, um zu sehen, wie die Früchte reagieren.
                        Auch wenn sich die Ergebnisse erst mit der Zeit zeigen werden, ist es zweifelhaft, ob dieses neue Unterfangen welche bringen wird
                        Investitionsmöglichkeiten in naher Zukunft. Doch mit einem Weinbau-Stammbaum wie dem ihren,
                        Es könnte klug sein, diesen Bereich im Auge zu behalten.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vale Meao</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Mentionnez le nom de Dona Antónia Adelaide Ferreira au Portugal et ils fredonneront avec révérence. UN
                        source de fierté nationale, "la Ferreirinha" - surnom donné à Antonia par ses ouvriers - est
                        la raison pour laquelle le vin de Porto jouit de l'illustre réputation qu'il a aujourd'hui. Le dernier morceau d'elle
                        Puzzle de Porto des domaines légendaires (il y en avait presque 30 au total), Quinta Do Vale Meao
                        (prononcer miaow) est une véritable institution du Douro.
                    </div>

                    <div class="howto-title2">L'un des plus grands domaines familiaux de la vallée du Duro</div>
                    <div class="howto-text">
                        À 300 hectares et à 200 kilomètres de Porto, Quinta Do Vale Meao était le dernier projet de la Ferreirinha, mais le plus important. Plantée en 1877, à la fin des années 1880, elle gérait tous ses domaines
                        presque à lui tout seul. Pourtant, démarrer Quinta Do Vale Meao était un défi; placé si haut dans le
                        vallée, la riche mosaïque de terroirs était primordiale pour les raisins de Porto, mais la distance (12 jours
                        balade en char à bœufs) était rebutante pour les travailleurs. Alors qu'a fait la Ferreirinha ? Faire pression sur le
                        gouvernement portugais pour construire le chemin de fer jusqu'à Foz Côa, (le village où Quinta Do Vale
                        Meao est situé) bien sûr. Simple.
                        <br><br>
                        Aujourd'hui, le domaine est géré par l'équipe frère et sœur Francisco (Xito) et Luisa Olazabal, la
                        sixième génération dirige le vignoble. La famille a peu à peu replanté les vignes en single
                        blocs depuis 1971, en remplacement des cépages traditionnels pour Porto. Le vin est riche et
                        complexe, et comme certains de ses vignobles frères, les raisins sont encore foulés à pied pendant quatre
                        heures de grandes cuves en pierre (appelées lagares). La fermentation, cependant, est à la pointe de la technologie et
                        s'effectue dans des cuves inox thermorégulées. Le vieillissement s'opère alors dans l'Allier
                        Barriques de chêne français. Une telle diligence et un tel respect de la tradition ont valu à Xito le titre de
                        Vigneron portugais de l'année en 2011.
                    </div>

                    <div class="howto-title2">L'avenir est prometteur</div>
                    <div class="howto-text">
                        Il est intéressant de voir que Xito et Luisa ont de grands projets pour l'avenir. L'exportation est
                        large et varié; Quinta Do Vale Meao se trouve au Brésil, Canada, Allemagne, Macao, Suisse
                        et les États-Unis et Xito et Luisa recherchent activement d'autres pays pour importer leur port
                        vin. Ils ont également planté une variété de raisins de table, pour voir comment le fruit réagira,
                        bien que seul le temps nous dira sur les résultats, il est douteux que cette nouvelle entreprise donnera des résultats
                        possibilités d'investissement dans un avenir proche. Cependant, avec un pedigree viticole comme le leur,
                        il serait peut-être judicieux de surveiller cet espace.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vale Meao</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Mention the name Dona Antónia Adelaide Ferreira in Portugal and they will hum with reverence. A
                        source of national pride, “la Ferreirinha” - the nickname given to Antonia by her workers - is
                        the reason why Port wine enjoys the illustrious reputation it has today. The final piece of her
                        Porto puzzle of legendary estates (there were almost 30 in total), Quinta Do Vale Meao
                        (pronounced miaow) is a veritable institution of the Douro.
                    </div>

                    <div class="howto-title2">One of the Duro valley’s greatest family owned estates</div>
                    <div class="howto-text">
                        At 300-hectacres and 200-kilometres from Porto, Quinta Do Vale Meao was la Ferreirinha last, but most significant project. Planted in 1877, by the late 1880s she was managing all of her estates
                        almost single-handedly. Yet starting Quinta Do Vale Meao was challenging; set so high in the
                        valley the rich patchwork of terroir was prime for Port wine grapes, yet the distance (a 12-day
                        ox-cart ride) was offputting for workers. So what did la Ferreirinha do? Put pressure on the
                        Portuguese government to build the railway up to the Foz Côa, (the village where Quinta Do Vale
                        Meao is located) of course. Simple.
                        <br><br>
                        Today the estate is run by brother and sister team Francisco (Xito) and Luisa Olazabal, the
                        sixth generation run the vineyard. The family has been slowly replanting the vines in single
                        blocks since 1971, replacing with the traditional varietals for Porto. The wine is rich and
                        complex, and like some of its sister vineyards, the grapes are still trodden by foot for four
                        hours large stone vats (called lagares). The fermentation, however, is state of the art and
                        takes place in temperature controlled stainless steel vats. Ageing then takes place in Allier
                        French oak barriques. Such diligence and respect for tradition earnt Xito the title of
                        Portugal’s winemaker of the Year in 2011.
                    </div>

                    <div class="howto-title2">The future&#39;s bright</div>
                    <div class="howto-text">
                        It is interesting to see that Xito and Luisa have great plans for the future. Exportation is
                        wide and varied; Quinta Do Vale Meao can be found in Brazil, Canada, Germany, Macau, Switzerland
                        and the USA and Xito and Luisa are actively looking for other countries to import their Port
                        wine. They have also planted a variety of table wine grapes, to see how the fruit will react,
                        although only time will tell on the results, it is doubtful that this new venture will yield any
                        investment opportunities in the near future. However, with a winemaking pedigree such as theirs,
                        it might be wise to watch this space.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "QuintaDoValeMeao",
    data() {
        return {
            select: {report: 'Quinta Do Vale Meao', src: '/wine-guide/portugal/douro-valley/quinta-do-vale-meao'},
            items: [
                {report: 'Casa Ferreirinha', src: '/wine-guide/portugal/douro-valley/casa-ferreirinha'},
                {report: 'Howard’s Folly', src: '/wine-guide/portugal/douro-valley/howards-folly'},
                {
                    report: 'Prats and Symington (Chryseia)',
                    src: '/wine-guide/portugal/douro-valley/prats-and-symington'
                },
                {report: 'Quinta do Crasto', src: '/wine-guide/portugal/douro-valley/quinta-do-crasto'},
                {report: 'Quinta Do Vale Meao', src: '/wine-guide/portugal/douro-valley/quinta-do-vale-meao'},
                {report: 'Quinta Do Vallado', src: '/wine-guide/portugal/douro-valley/quinta-do-vallado'},
                {report: 'Quinta Do Vesuvio', src: '/wine-guide/portugal/douro-valley/quinta-do-vesuvio'},
                {
                    report: 'Roquette & Cazes — Quinta do Crasto',
                    src: '/wine-guide/portugal/douro-valley/roquette-cazes-quinta'
                },
                {report: 'Symington', src: '/wine-guide/portugal/douro-valley/symington'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Quinta Do Vale Meao | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich and bold wines of Quinta Do Vale Meao, a renowned wine producer in the Douro Valley. Our expert winemakers blend traditional winemaking techniques with modern technology to create a range of exceptional wines. Visit our vineyards and taste the passion and quality in every sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
